let state = {}

try {
  state = JSON.parse(process.env.GATSBY_INITIAL_STATE)
} catch (err) {
  // noop
}

export const injectedState = state
